module.exports = __webpack_public_path__ + "img/Atmos Haus der Musik-Grosser Saal_2.jpg";